import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StorageService } from './storage.service';
import { ShareStoryPromptComponent } from '../shared/share-story-prompt/share-story-prompt.component';

const TESTIMONIAL_PROMPT_KEY = 'testimonial_prompt_shown';

@Injectable({
  providedIn: 'root'
})
export class TestimonialPromptService {

  constructor(
    private modalService: NgbModal,
    private storageService: StorageService
  ) {}

  promptForTestimonial(): void {
    if (this.storageService.getData(TESTIMONIAL_PROMPT_KEY)) {
      return;
    }

    this.storageService.setData(TESTIMONIAL_PROMPT_KEY, 'true');

    this.modalService.open(ShareStoryPromptComponent, {
      centered: true,
      size: 'md',
      backdrop: true,
      windowClass: 'share-story-prompt-modal'
    });
  }

  resetSession(): void {
    this.storageService.removeData(TESTIMONIAL_PROMPT_KEY);
  }
}
